import React from 'react';

interface ModalTitleProps {
  text: string;
  className?: string;
}

export default function ModalTitle({ text, className }: ModalTitleProps) {
  return <p className={`section-title ${className}`}>{text}</p>;
}
